import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm, NgModel } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Gleba } from 'src/app/classes/Gleba';
import { GlebaService } from 'src/app/services/gleba.service';
import { CustomToastyService } from 'src/app/theme/shared/components/toasty/custom-toasty.service';
import { UtilsService } from 'src/app/utils/utils.service';
import { UiModalComponent } from 'src/app/theme/shared/components/modal/ui-modal/ui-modal.component';

@Component({
  selector: 'app-forms-gleba',
  templateUrl: './forms-gleba.component.html',
  styleUrls: ['./forms-gleba.component.scss']
})
export class FormsGlebaComponent implements OnInit {

  @Input() areaId: number = 0;
  @Output() finalizarSave: EventEmitter<void> = new EventEmitter();
  @Output() cancelar: EventEmitter<void> = new EventEmitter();

  @ViewChild('GlebaModal', { static: false }) GlebaModal: UiModalComponent;
  @ViewChild('formularioGleba', { static: false }) formularioGleba: NgForm;

  gleba: Gleba = new Gleba();
  carregando: boolean = false;
  isSubmit: boolean = false;

  // Traduções
  ERRO: string = 'Erro!';
  FEITO: string = 'Feito!';
  GLEBA_DELETADA: string = 'Gleba deletada!';
  GLEBA_CADASTRADA: string = 'Gleba cadastrada!';
  GLEBA_ALTERADA: string = 'Gleba alterada!';
  NENHUMA_AREA_INFORMADA: string = 'Nenhuma área informada';

  constructor(
    private glebaService: GlebaService,
    private utils: UtilsService,
    private translate: TranslateService,
    private toasty: CustomToastyService
  ) {}

  ngOnInit() {
    this.configurarTraducao();
  }

  configurarTraducao() {
    this.ERRO = this.translate.instant('ERRO');
    this.FEITO = this.translate.instant('FEITO');
    this.GLEBA_DELETADA = this.translate.instant('GLEBA_DELETADA');
    this.GLEBA_CADASTRADA = this.translate.instant('GLEBA_CADASTRADA');
    this.GLEBA_ALTERADA = this.translate.instant('GLEBA_ALTERADA');
    this.NENHUMA_AREA_INFORMADA = this.translate.instant('NENHUMA_AREA_INFORMADA');
  }

  show(gleba?: Gleba, areaId?: number) {
    if (gleba) {
      this.gleba = { ...gleba };
    } else {
      this.gleba = new Gleba();
    }
    if (areaId) {
      this.areaId = areaId;
    }
    this.isSubmit = false;
    this.GlebaModal.show();
  }

  hide() {
    this.GlebaModal.hide();
  }

  saveGleba(form: any) {
    this.configurarTraducao();
    if (!form.valid) {
      this.isSubmit = true;
      return;
    }
    if (this.areaId <= 0) {
      this.utils.handleWarning(this.NENHUMA_AREA_INFORMADA);
      this.carregando = false;
      return;
    }
    this.carregando = true;
    this.gleba.AreaId = this.areaId;

    if (this.gleba.Id > 0)
      this.glebaService.putGleba(this.gleba.Id, this.gleba).subscribe(
        res => {
          this.toasty.show(this.FEITO, this.GLEBA_ALTERADA, 'success');
          this.carregando = false;
          this.GlebaModal.hide();
          this.finalizarSave.emit();
        },
        err => {
          this.utils.getErro(err);
          this.carregando = false;
        });
    else
      this.glebaService.postGleba(this.gleba).subscribe(
        res => {
          this.toasty.show(this.FEITO, this.GLEBA_CADASTRADA, 'success');
          this.carregando = false;
          this.GlebaModal.hide();
          this.finalizarSave.emit();
        },
        err => {
          this.utils.getErro(err);
          this.carregando = false;
        });
  }

  cancelarGleba() {
    this.GlebaModal.hide();
    this.cancelar.emit();
  }

  isCampoInvalido(campo: NgModel): boolean {
    return (
      !campo.valid &&
      (campo.dirty || campo.touched || this.isSubmit)
    );
  }
}

